<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [showHeader]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-xl premium-dialog payment-dialog"
  (onHide)="onClose()"
>
  <div class="premium-dialog-container">
    <div class="premium-header">
      <div class="premium-header-content">
        <h3 class="premium-title">{{ config.title || "Payment & Total Details" }}</h3>
        <p class="premium-subtitle">
          Amount due ₹{{ getRoundedTotal() | number: "1.2-2" }}
          <ng-container *ngIf="paymentData.customerName"> · {{ paymentData.customerName }}</ng-container>
        </p>
      </div>
      <button type="button" class="premium-close-btn" (click)="onClose()" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="premium-body payment-dialog-content">
      <!-- Customer -->
      <div class="pd-customer">
        <div class="pd-field">
          <label class="pd-label" for="pdMobile">Mobile Number <span class="pd-req">*</span></label>
          <input
            pInputText
            id="pdMobile"
            type="text"
            class="pd-input"
            [(ngModel)]="paymentData.mobileNumber"
            (ngModelChange)="onPaymentDataUpdate()"
            (keypress)="allowOnlyNumbers($event)"
            (paste)="handleMobileNumberPaste($event)"
            (input)="onMobileNumberInput($event)"
            maxlength="10"
            inputmode="numeric"
            pattern="[0-9]*"
            placeholder="Enter mobile number"
            [readonly]="config.isCashManagement"
            required
          />
        </div>
        <div class="pd-field">
          <label class="pd-label">Customer Name</label>
          <p-autoComplete
            *ngIf="!config.isCashManagement"
            [(ngModel)]="paymentData.customerName"
            [suggestions]="filteredCustomers"
            (completeMethod)="filterCustomers($event)"
            (onSelect)="onCustomerSelectFromAutocomplete($event)"
            (ngModelChange)="onPaymentDataUpdate()"
            optionLabel="customer_name"
            [dropdown]="true"
            [forceSelection]="false"
            placeholder="Enter customer name"
            styleClass="customer-name-autocomplete-payment"
            inputStyleClass="pd-input"
          >
            <ng-template let-customer pTemplate="item">
              <div class="customer-option">
                <div class="customer-name-text">{{ customer.customer_name }}</div>
                <div class="customer-mobile-text">{{ customer.mobile_no }}</div>
              </div>
            </ng-template>
          </p-autoComplete>
          <input
            *ngIf="config.isCashManagement"
            pInputText
            type="text"
            class="pd-input"
            [(ngModel)]="paymentData.customerName"
            (ngModelChange)="onPaymentDataUpdate()"
            maxlength="20"
            placeholder="Enter customer name"
            readonly
          />
        </div>
      </div>

      <div class="pd-layout">
        <div class="pd-main">
          <!-- Payment method tiles -->
          <div class="payment-method-tabs" role="tablist">
            <button
              type="button"
              class="payment-tab-btn"
              [class.active]="activePaymentTab === 'Cash'"
              (click)="setActivePaymentTab('Cash')"
            >
              <i class="pi pi-wallet"></i>
              <span>Cash</span>
            </button>
            <button
              type="button"
              class="payment-tab-btn"
              [class.active]="activePaymentTab === 'Card'"
              (click)="setActivePaymentTab('Card')"
              [disabled]="config.isExchangeOrder"
            >
              <i class="pi pi-credit-card"></i>
              <span>Card</span>
            </button>
            <button
              type="button"
              class="payment-tab-btn"
              [class.active]="activePaymentTab === 'UPI'"
              (click)="setActivePaymentTab('UPI')"
              [disabled]="config.isExchangeOrder"
            >
              <i class="pi pi-mobile"></i>
              <span>UPI</span>
            </button>
            <button
              type="button"
              class="payment-tab-btn redeem-points-tab"
              [class.active]="activePaymentTab === 'Redeem Points'"
              (click)="setActivePaymentTab('Redeem Points')"
              [disabled]="!config.isExchangeOrder && isAnyPartPaymentEnabled()"
              *ngIf="config.showRedeemPoints"
            >
              <i class="pi" [class.pi-gift]="!config.isExchangeOrder" [class.pi-credit-card]="config.isExchangeOrder"></i>
              <span>{{ config.isExchangeOrder ? "Add to Credit" : "Redeem Points" }}</span>
            </button>
            <button
              type="button"
              class="payment-tab-btn split-tab"
              [class.active]="activePaymentTab === 'Split'"
              (click)="setActivePaymentTab('Split')"
              [disabled]="config.isExchangeOrder || isAnyPartPaymentEnabled()"
              *ngIf="config.showSplit"
            >
              <i class="pi pi-clone"></i>
              <span>Split</span>
            </button>
          </div>

          <!-- Amount inputs for the active method -->
          <div class="payment-amounts-section">
            <div *ngIf="activePaymentTab === 'Cash'" class="payment-input-section">
              <div class="pd-field">
                <div class="pd-label-row" *ngIf="!config.isCashManagement">
                  <label class="pd-label">Cash Amount</label>
                  <label class="pd-switch" for="partPaymentCash">
                    <input
                      type="checkbox"
                      [(ngModel)]="isPartPaymentCash"
                      (ngModelChange)="onPartPaymentToggle('Cash', $event)"
                      id="partPaymentCash"
                      [disabled]="config.isExchangeOrder || isPartPaymentCard || isPartPaymentUPI"
                    />
                    Credit
                  </label>
                </div>
                <label class="pd-label" *ngIf="config.isCashManagement">Cash Amount</label>
                <p-inputNumber
                  [(ngModel)]="paymentData.cashAmount"
                  mode="decimal"
                  locale="en-US"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  [useGrouping]="false"
                  prefix="₹"
                  [min]="0"
                  styleClass="pd-amount"
                  placeholder="Enter cash amount"
                  (ngModelChange)="onPaymentDataUpdate()"
                >
                </p-inputNumber>
              </div>
            </div>

            <div *ngIf="activePaymentTab === 'Card'" class="payment-input-section">
              <div class="pd-field">
                <div class="pd-label-row" *ngIf="!config.isCashManagement">
                  <label class="pd-label">Card Amount</label>
                  <label class="pd-switch" for="partPaymentCard">
                    <input
                      type="checkbox"
                      [(ngModel)]="isPartPaymentCard"
                      (ngModelChange)="onPartPaymentToggle('Card', $event)"
                      id="partPaymentCard"
                      [disabled]="config.isExchangeOrder || isPartPaymentCash || isPartPaymentUPI"
                    />
                    Credit
                  </label>
                </div>
                <label class="pd-label" *ngIf="config.isCashManagement">Card Amount</label>
                <p-inputNumber
                  [(ngModel)]="paymentData.cardAmount"
                  mode="decimal"
                  locale="en-US"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  [useGrouping]="false"
                  prefix="₹"
                  [min]="0"
                  styleClass="pd-amount"
                  placeholder="Enter card amount"
                  (ngModelChange)="onPaymentDataUpdate()"
                >
                </p-inputNumber>
              </div>
              <div class="pd-grid-2">
                <div class="pd-field">
                  <label class="pd-label">{{ config.isCashManagement ? "Card Number" : "Cardholder Name" }}</label>
                  <input
                    pInputText
                    type="text"
                    class="pd-input"
                    [(ngModel)]="paymentData.cardNumber"
                    (ngModelChange)="onPaymentDataUpdate()"
                    [placeholder]="config.isCashManagement ? 'Enter card number' : 'Enter name'"
                  />
                </div>
                <div class="pd-field">
                  <label class="pd-label">Transaction ID</label>
                  <input
                    pInputText
                    type="text"
                    class="pd-input"
                    [(ngModel)]="paymentData.cardTransactionId"
                    (ngModelChange)="onPaymentDataUpdate()"
                    placeholder="Enter transaction ID"
                  />
                </div>
              </div>
            </div>

            <div *ngIf="activePaymentTab === 'UPI'" class="payment-input-section">
              <div class="pd-field">
                <div class="pd-label-row" *ngIf="!config.isCashManagement">
                  <label class="pd-label">UPI Amount</label>
                  <label class="pd-switch" for="partPaymentUPI">
                    <input
                      type="checkbox"
                      [(ngModel)]="isPartPaymentUPI"
                      (ngModelChange)="onPartPaymentToggle('UPI', $event)"
                      id="partPaymentUPI"
                      [disabled]="config.isExchangeOrder || isPartPaymentCash || isPartPaymentCard"
                    />
                    Credit
                  </label>
                </div>
                <label class="pd-label" *ngIf="config.isCashManagement">UPI Amount</label>
                <p-inputNumber
                  [(ngModel)]="paymentData.upiAmount"
                  mode="decimal"
                  locale="en-US"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  [useGrouping]="false"
                  prefix="₹"
                  [min]="0"
                  styleClass="pd-amount"
                  placeholder="Enter UPI amount"
                  (ngModelChange)="onPaymentDataUpdate()"
                >
                </p-inputNumber>
              </div>
              <div class="pd-grid-2">
                <div class="pd-field">
                  <label class="pd-label">UPI ID</label>
                  <input
                    pInputText
                    type="text"
                    class="pd-input"
                    [(ngModel)]="paymentData.upiId"
                    (ngModelChange)="onPaymentDataUpdate()"
                    placeholder="Enter UPI ID"
                  />
                </div>
                <div class="pd-field">
                  <label class="pd-label">Transaction ID</label>
                  <input
                    pInputText
                    type="text"
                    class="pd-input"
                    [(ngModel)]="paymentData.upiTransactionId"
                    (ngModelChange)="onPaymentDataUpdate()"
                    placeholder="Enter transaction ID"
                  />
                </div>
              </div>
            </div>

            <div *ngIf="activePaymentTab === 'Redeem Points' && config.showRedeemPoints" class="payment-input-section">
              <div *ngIf="config.isExchangeOrder" class="pd-notice">
                <i class="pi pi-credit-card"></i>
                <div>
                  <strong>Add to Credit</strong>
                  <p>
                    Exchange amount of
                    <strong>{{ getRoundedTotal() | currency: "INR" : "symbol" : "1.2-2" }}</strong>
                    will be added to customer credit.
                  </p>
                  <small>No payment required - amount will be credited to customer account.</small>
                </div>
              </div>

              <div *ngIf="!config.isExchangeOrder" class="pd-field">
                <label class="pd-label">Amount</label>
                <p-inputNumber
                  [(ngModel)]="paymentData.redeemPointsAmount"
                  mode="decimal"
                  locale="en-US"
                  [minFractionDigits]="0"
                  [maxFractionDigits]="2"
                  [useGrouping]="false"
                  prefix="₹"
                  [min]="0"
                  styleClass="pd-amount"
                  placeholder="0"
                  (ngModelChange)="onPaymentDataUpdate()"
                >
                </p-inputNumber>
              </div>
            </div>

            <div *ngIf="activePaymentTab === 'Split' && config.showSplit" class="payment-input-section split-payment-section">
              <div class="pd-grid-3">
                <div class="pd-field">
                  <label class="pd-label">Cash</label>
                  <p-inputNumber
                    [(ngModel)]="paymentData.splitPaymentAmounts!.cash"
                    mode="decimal"
                    locale="en-US"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="2"
                    [useGrouping]="false"
                    prefix="₹"
                    [min]="0"
                    styleClass="pd-amount split-input"
                    placeholder="Rs 0"
                    (ngModelChange)="onPaymentDataUpdate()"
                  >
                  </p-inputNumber>
                </div>
                <div class="pd-field">
                  <label class="pd-label">Card</label>
                  <p-inputNumber
                    [(ngModel)]="paymentData.splitPaymentAmounts!.card"
                    mode="decimal"
                    locale="en-US"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="2"
                    [useGrouping]="false"
                    prefix="₹"
                    [min]="0"
                    styleClass="pd-amount split-input"
                    placeholder="Rs 0"
                    (ngModelChange)="onPaymentDataUpdate()"
                  >
                  </p-inputNumber>
                </div>
                <div class="pd-field">
                  <label class="pd-label">UPI</label>
                  <p-inputNumber
                    [(ngModel)]="paymentData.splitPaymentAmounts!.upi"
                    mode="decimal"
                    locale="en-US"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="2"
                    [useGrouping]="false"
                    prefix="₹"
                    [min]="0"
                    styleClass="pd-amount split-input"
                    placeholder="Rs 0"
                    (ngModelChange)="onPaymentDataUpdate()"
                  >
                  </p-inputNumber>
                </div>
              </div>

              <!-- Card details (shown when card amount > 0) -->
              <div class="pd-grid-2" *ngIf="paymentData.splitPaymentAmounts!.card > 0">
                <div class="pd-field">
                  <label class="pd-label">{{ config.isCashManagement ? "Card Number" : "Cardholder Name" }}</label>
                  <input
                    pInputText
                    type="text"
                    class="pd-input"
                    [(ngModel)]="paymentData.cardNumber"
                    (ngModelChange)="onPaymentDataUpdate()"
                    [placeholder]="config.isCashManagement ? 'Enter card number' : 'Enter name'"
                  />
                </div>
                <div class="pd-field">
                  <label class="pd-label">Transaction ID</label>
                  <input
                    pInputText
                    type="text"
                    class="pd-input"
                    [(ngModel)]="paymentData.cardTransactionId"
                    (ngModelChange)="onPaymentDataUpdate()"
                    placeholder="Enter transaction ID"
                  />
                </div>
              </div>

              <!-- UPI details (shown when UPI amount > 0) -->
              <div class="pd-grid-2" *ngIf="paymentData.splitPaymentAmounts!.upi > 0">
                <div class="pd-field">
                  <label class="pd-label">UPI ID</label>
                  <input
                    pInputText
                    type="text"
                    class="pd-input"
                    [(ngModel)]="paymentData.upiId"
                    (ngModelChange)="onPaymentDataUpdate()"
                    placeholder="Enter UPI ID"
                  />
                </div>
                <div class="pd-field">
                  <label class="pd-label">Transaction ID</label>
                  <input
                    pInputText
                    type="text"
                    class="pd-input"
                    [(ngModel)]="paymentData.upiTransactionId"
                    (ngModelChange)="onPaymentDataUpdate()"
                    placeholder="Enter transaction ID"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Totals -->
          <div class="payment-summary-section">
            <div class="summary-item">
              <span class="summary-label">Total Amount</span>
              <span class="summary-value">Rs {{ getRoundedTotal() | number: "1.2-2" }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">Paid Amount</span>
              <span class="summary-value paid-amount">Rs {{ getPaidAmount() | number: "1.2-2" }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">TIP Amount</span>
              <span class="summary-value">Rs {{ getTipAmount() | number: "1.2-2" }}</span>
            </div>
            <div class="summary-item">
              <span class="summary-label">{{ getBalanceLabel() }}</span>
              <span class="summary-value" [ngClass]="isRefundScenario() ? 'refund-amount' : 'balance-amount'">
                Rs {{ getBalanceAmount() | number: "1.2-2" }}
              </span>
            </div>
          </div>
        </div>

        <!-- Keypad -->
        <div class="numeric-keypad">
          <div class="keypad-grid">
            <button type="button" class="keypad-btn" (click)="addToAmount('7')" tabindex="-1">7</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('8')" tabindex="-1">8</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('9')" tabindex="-1">9</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('4')" tabindex="-1">4</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('5')" tabindex="-1">5</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('6')" tabindex="-1">6</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('1')" tabindex="-1">1</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('2')" tabindex="-1">2</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('3')" tabindex="-1">3</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('.')" tabindex="-1">•</button>
            <button type="button" class="keypad-btn" (click)="addToAmount('0')" tabindex="-1">0</button>
            <button type="button" class="keypad-btn backspace-btn" (click)="backspaceAmount()" tabindex="-1" aria-label="Backspace">
              <i class="pi pi-arrow-left"></i>
            </button>
            <button type="button" class="keypad-btn clear-btn" (click)="clearAmount()" tabindex="-1">CLEAR</button>
          </div>
        </div>
      </div>
    </div>

    <div class="premium-footer dialog-footer">
      <span class="footer-info">
        <i class="pi pi-info-circle"></i>
        Exact: ₹{{ paymentData.totalAmount | number: "1.2-2" }}, Round Off: ₹{{
          getRoundedTotal() - paymentData.totalAmount | number: "1.2-2"
        }}
      </span>
      <button type="button" class="premium-btn premium-btn-secondary" (click)="onClose()" [disabled]="isProcessing" tabindex="0">
        <i class="pi pi-times"></i>
        Cancel
      </button>
      <button
        type="button"
        class="premium-btn premium-btn-primary"
        (click)="onProcessPayment()"
        [disabled]="isProcessing || (getBalanceAmount() !== 0 && !isRefundScenario())"
        tabindex="0"
      >
        <i class="pi pi-check" *ngIf="!isProcessing"></i>
        <i class="pi pi-spin pi-spinner" *ngIf="isProcessing"></i>
        {{ isProcessing ? "Processing..." : "Process Payment" }}
      </button>
    </div>
  </div>
</p-dialog>
